module.exports = __webpack_public_path__ + "Flag-810.6f194c7c73c9d5e7e95a2e0437a13c35.svg";